export default function genCoordFromAngle(rad: number , radius: number) {
  return  { x: Math.cos(rad) * radius, y: Math.sin(rad) * radius };
}